export function getMetaTitle(subtitle?: string) {
	const baseTitle = 'Nicolás Mainella'
	if (!subtitle) return baseTitle
	return `${baseTitle} - ${subtitle}`
}
